import { FieldError } from '@components/field-error';
import { GhostButton } from '@components/form/button/ghost-button';
import { AppModal } from '@components/form/Modal';
// import { isValidPhoneNumber } from '@shared/utils/contact-helper';
import { Empty, InputRef, Modal } from 'antd';
import { KeyboardEventHandler, useRef, useState } from 'react';
// import { RiAddLine } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import { useBulkMessaging } from './hooks/use-bulk-messaging';
import { useBulkMessagingRecentContacts } from './hooks/use-bulk-messaging-recent-contacts';
import { ContactSelectList } from './components/bulk-messaging/contact-select-list';
// import { SelectedContactTags } from './components/bulk-messaging/selected-contact-tags';
// import { AppPrimaryButton } from '@components/form/button/app-primary-button';
import { SearchContactInput } from './components/search-contact-input';

type Props = {
  open: boolean;
  handleClose: VoidFunction;
  // runs after navigating to compose, so the parent modal this one is nested in can close too
  onContinue?: VoidFunction;
};

function NewBulkMessagingModal({ open, handleClose, onContinue }: Props) {
  const { t } = useTranslation();
  const [searchInput, setSearchInput] = useState('');
  const [error, setError] = useState('');
  const searchInputRef = useRef<InputRef>(null);

  const {
    goToCompose,
    reset,
    contacts,
    hasNextPage,
    loadNextRef,
    isSearching,
    selectedContactIds,
    handleContactToggle,
    handleBulkToggle,
  } = useBulkMessaging(searchInput);
  const recentContacts = useBulkMessagingRecentContacts();
  const isSearching_ = searchInput.trim().length > 0;
  const onClose = () => {
    reset();
    setSearchInput('');
    setError('');
    handleClose();
  };

  const handleContinue = () => {
    goToCompose();
    onClose();
    onContinue?.();
  };

  // const onAddNumber = () => {
  //   if (!isValidPhoneNumber(searchInput)) {
  //     setError(t('phone_number_is_invalid'));
  //     return;
  //   }
  //   handleAddNumber(searchInput);
  //   setSearchInput('');
  //   setError('');
  // };

  const onKeyDown: KeyboardEventHandler = (e) => {
    if (e.key !== 'Enter' || selectedContactIds.length === 0 || error.length > 0) return;
    handleContinue();
  };

  return (
    <Modal
      className="w-105!"
      centered
      onCancel={onClose}
      open={open}
      afterOpenChange={(isOpen) => isOpen && searchInputRef.current?.focus()}
      modalRender={(node) => <div onKeyDown={onKeyDown}>{node}</div>}
      title={
        <AppModal.Header>
          <AppModal.Title>New Bulk Messaging</AppModal.Title>
          <AppModal.SubTitle>Start a new conversation.</AppModal.SubTitle>
        </AppModal.Header>
      }
      footer={
        <AppModal.Footer>
          <GhostButton className="flex-1 capitalize!" onClick={onClose}>
            {t('back')}
          </GhostButton>
          <AppModal.Button
            loading={false}
            disabled={selectedContactIds.length === 0 || error.length > 0}
            className="flex-1 w-full capitalize!"
            type="primary"
            onClick={handleContinue}
          >
            {t('continue')}
          </AppModal.Button>
        </AppModal.Footer>
      }
    >
      <AppModal.Body>
        <SearchContactInput
          ref={searchInputRef}
          value={searchInput}
          onChange={(value) => {
            setError('');
            setSearchInput(value);
          }}
          error={error}
          // suffix={
          //   <AppPrimaryButton onClick={onAddNumber} className="size-6! rounded-full! p-1!">
          //     <RiAddLine className="text-white" />
          //   </AppPrimaryButton>
          // }
        />
        {error && <FieldError message={error} />}
        {contacts.length === 0 ? (
          <div className="max-h-131 overflow-y-auto flex items-center justify-center py-8">
            <Empty description="No contacts found" />
          </div>
        ) : (
          <div className="space-y-4 max-h-131 overflow-y-auto">
            {!isSearching_ && (
              <ContactSelectList
                title="RECENT"
                contacts={recentContacts}
                selectedContactIds={selectedContactIds}
                onToggle={handleContactToggle}
                onSelectAll={handleBulkToggle}
                showCheckbox
              />
            )}
            <ContactSelectList
              title="ALL CONTACTS"
              contacts={contacts}
              selectedContactIds={selectedContactIds}
              onToggle={handleContactToggle}
              onSelectAll={handleBulkToggle}
              showCheckbox
              hasNextPage={hasNextPage}
              loadMoreRef={loadNextRef}
              isSearching={isSearching}
            />
          </div>
        )}
      </AppModal.Body>
    </Modal>
  );
}

export default NewBulkMessagingModal;
